// Fallback site configuration. Live values are served from GET /api/config
// and are editable from the /admin panel (Site Settings tab).
export const FALLBACK_CONFIG = {
  businessName: "Chhannulal & Brothers",
  brandMark: "CLB",
  tagline: "Your Complete Home Solutions",
  phone: "+91 00000 00000",
  whatsapp: "910000000000",
  email: "enquiries@example.com",
  address: "Showroom address goes here — edit from the admin panel",
  hours: "Mon – Sat · 10:00 AM – 8:00 PM",
  mapsUrl: "",
  instagram: "#",
  facebook: "#",
  logoUrl: "",
  whatsappMessage: "Hello Chhannulal & Brothers, I would like to enquire about your products.",
};

export const waLink = (cfg, message) => {
  const text = encodeURIComponent(message || cfg.whatsappMessage);
  return `https://wa.me/${String(cfg.whatsapp).replace(/\D/g, "")}?text=${text}`;
};

export const telLink = (cfg) =>
  `tel:${String(cfg.phone).split(",")[0].replace(/[^+\d]/g, "")}`;
